import { Address } from '@funnels/types';

export const formatAreaAddressWithPostcode = (address?: Address) => {
  if (!address || !address.formatted) return undefined;
  if (!address.postcode || address.formatted.includes(`${address.state} ${address.postcode}`)) return address.formatted;
  const [city, state, country] = address.formatted.split(', ');
  return [city, `${state} ${address.postcode}`, country].join(', ');
};
